import { ColorSelectorUtil, SelectedColor } from "@mcleod/common";
import { AutogenLayoutGenericColorPicker } from "./autogen/AutogenLayoutGenericColorPicker";
import { DataSource, DataSourceExecutionEvent } from "@mcleod/components";

export class GenericColorPicker extends AutogenLayoutGenericColorPicker {
    private _profileDataSource: DataSource;
    private _fieldName: string = "status_color"; // Default field name
    private afterExecute = (event: DataSourceExecutionEvent) => {
        if (this._fieldName) {
            this.panelColorDisplay.backgroundColor = this._profileDataSource?.activeRow?.get(this._fieldName);
        }
    };

    get profileDataSource() {
        return this._profileDataSource;
    }

    set profileDataSource(value: DataSource) {
        if (this._profileDataSource) {
            this._profileDataSource.removeAfterExecutionListener(this.afterExecute);
        }
        this._profileDataSource = value;
        if (this._profileDataSource) {
            this._profileDataSource.addAfterExecutionListener(this.afterExecute);
        }
    }

    setField(dataSource: DataSource, fieldName: string) {
        // Remove listener from previous datasource
        if (this._profileDataSource) {
            this._profileDataSource.removeAfterExecutionListener(this.afterExecute);
        }
        
        this._profileDataSource = dataSource;
        this._fieldName = fieldName;
        
        // Add listener to new datasource
        if (this._profileDataSource) {
            this._profileDataSource.addAfterExecutionListener(this.afterExecute);
            // Update display immediately
            this.updateDisplay();
        }
    }

    buttonClearColorOnClick() {
        this.syncPlanningColor();
    }

    async buttonColorPickerOnClick() {
        const result = await ColorSelectorUtil.promptForHexColor();
        if (result?.hexColor) {
            this.syncPlanningColor(result);
        }
    }

    private syncPlanningColor(result: SelectedColor = {}) {
        if (!this._profileDataSource || !this._fieldName) return;
        
        const { colorName, hexColor } = result;
        this._profileDataSource.activeRow.set(this._fieldName, hexColor ?? null);
        this.panelColorDisplay.backgroundColor = colorName;
        this.panelColorDisplay.tooltip = hexColor;
    }

    private updateDisplay() {
        if (this._fieldName && this._profileDataSource?.activeRow) {
            this.panelColorDisplay.backgroundColor = this._profileDataSource.activeRow.get(this._fieldName);
        }
    }

    get dataSource() {
        return this._profileDataSource;
    }

    get fieldName() {
        return this._fieldName;
    }
}
